import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// (c) 2023 Acellera Ltd http://www.acellera.com
// All Rights Reserved
// No redistribution in whole or part
//
import { shallow } from "zustand/shallow";
import { useEffect, useState } from "react";
import { userAuthStore } from "../..";
import { Redirect, Route, useLocation } from "wouter";
import { Fade, Box, Grid, IconButton, Typography, Paper, } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { NestedRoutes } from "../..//utils/NestedRoutes";
import { AppPanel } from "../../apps/ApplicationsMenu/AppPanel";
import { JobsStatus } from "../../apps/jobs/JobsStatus";
import { AppListStore } from "../../apps/ApplicationsMenu/appList.store";
import { MolSystemsPanel } from "../../3dViewer/MolSystemsPanel";
import { DatacenterBrowser } from "../../DatacenterBrowser/MainComponent";
import { ApplicationsMenu } from "../../apps/ApplicationsMenu/ApplicationsMenu";
import { Apps } from "../../GenericViewerState/SharedState";
import { leftPanel } from "../panelDimensions";
import { ProjectSelector } from "../../apps/ProjectSelector/ProjectSelector";
export const AppsPanel = ({ vss, molstar, pyodide, pyodideReady, NAPGenericStore, }) => {
    const [currLoc, setLoc] = useLocation();
    const isActive = currLoc.startsWith("/tools");
    const [userInfo, waitUserInfo] = userAuthStore((state) => [state.userInfo, state.waitUserInfo], shallow);
    const isAuthenticated = !!userInfo;
    const [appList] = AppListStore((s) => [s.appList]);
    const [, /*autKdeepModel*/ setAutKdeepModel] = useState("");
    useEffect(() => {
        const _cb = (e) => {
            const { modelPath } = e.detail;
            setAutKdeepModel(modelPath);
        };
        window.addEventListener("PM-kdeep-setModel", _cb);
        return () => {
            window.removeEventListener("PM-kdeep-setModel", _cb);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const [activeSystemRadio, setActiveSystemRadio, setRequireFilesWExtension, activePanels, consolePanelHeight,] = NAPGenericStore((state) => [
        state._activeSystemRadio,
        state.setActiveSystemRadio,
        state.setRequireFilesWExtension,
        state._activePanels,
        state.consolePanelHeight,
    ], shallow);
    useEffect(() => {
        setActiveSystemRadio("");
        setRequireFilesWExtension([]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currLoc]);
    const noAuthURLS = ["/", "/login", "/docs", "/landing"];
    const requestingProtectedRoute = !waitUserInfo &&
        !isAuthenticated &&
        !((noAuthURLS.includes(window.location.pathname) ||
            window.location.pathname.startsWith("/docs/") ||
            window.location.pathname.startsWith("/data") ||
            window.location.pathname.includes("/auth/google/callback"))
        // window.location.pathname.startsWith("/auth/") ||
        // window.location.pathname === "/v2/auth/google/callback"
        );
    const dimensions = Object.assign(Object.assign({}, leftPanel), { left: (theme) => `calc(${theme.spacing(7)})`, backgroundColor: "white", maxHeight: `calc(100vh - ${consolePanelHeight} + 1.2em)` });
    return (_jsx(Fade, Object.assign({ in: isActive }, { children: _jsx(Box, Object.assign({ id: "apps-entrypoint" }, { children: _jsx(Box, Object.assign({ sx: dimensions }, { children: _jsxs(Grid, Object.assign({ container: true, direction: "column", sx: { height: "100%", pb: 2 }, wrap: "nowrap" }, { children: [_jsxs(Grid, Object.assign({ container: true, item: true, xs: "auto", direction: "row", sx: { p: 1, pb: 0 }, justifyContent: "flex-start", alignItems: "center" }, { children: [_jsx(Grid, Object.assign({ item: true, xs: "auto" }, { children: _jsx(IconButton, Object.assign({ color: "primary", onClick: () => backToParent(currLoc, setLoc) }, { children: _jsx(ArrowBackIcon, {}) })) })), _jsx(Grid, Object.assign({ item: true, xs: true, sx: { justifyContent: "center" } }, { children: _jsx(Box, Object.assign({ display: "flex", justifyContent: "center", alignItems: "center", sx: { mr: "40px" } }, { children: _jsx(ProjectSelector, {}) })) }))] })), _jsx(Grid, Object.assign({ item: true, xs: true, sx: { overflowY: "auto" } }, { children: requestingProtectedRoute ? (_jsx(_Fragment, { children: _jsx(Redirect, { to: `/login?from=${window.location.pathname}` }) })) : (_jsxs(_Fragment, { children: [_jsx(Route, Object.assign({ path: "/tools" }, { children: _jsx(ApplicationsMenu, { NAPGenericStore: NAPGenericStore }) })), _jsxs(NestedRoutes, Object.assign({ base: "/tools/" }, { children: [_jsx(Route, Object.assign({ path: Apps.datacenter }, { children: _jsx(DatacenterBrowser, { vss: vss, molstar: molstar, pyodide: pyodide, showFileActions: true, pyodideReady: pyodideReady, NAPGenericStore: NAPGenericStore }) }), "apps-route-datacenter"), appList.map((app) => (_jsx(Route, Object.assign({ path: app.name }, { children: _jsx(AppPanel, { manifest: app, pyodide: pyodide }) }), `apps-route-base${app.name}`))), _jsx(Route, Object.assign({ path: Apps.jobs }, { children: _jsx(JobsStatus, { pyodide: pyodide }) }), "apps-route-jobs")] }))] })) })), activeSystemRadio ? (_jsxs(Grid, Object.assign({ item: true, xs: true, sx: { overflowY: "auto", m: 2 }, component: Paper, variant: "outlined" }, { children: [_jsx(Typography, Object.assign({ variant: "body2", sx: { m: 2 } }, { children: "System selection:" })), _jsx(MolSystemsPanel, { vss: vss, molstar: molstar, pyodide: pyodide, positionInTree: [], NAPGenericStore: NAPGenericStore })] }))) : null] })) })) })) })));
};
export function dispatchSetModelEvent({ modelPath }) {
    window.dispatchEvent(new CustomEvent("PM-kdeep-setModel", {
        detail: { modelPath: modelPath },
    }));
}
const backToParent = (currentLocation, setLocation) => {
    if (currentLocation.startsWith("/tools/"))
        setLocation("/tools");
    else
        setLocation("/");
};
